export function parseCopyright(markdown: string) {
  return markdown.replace(
    /\[([^\]]+)\]\(([^)]+)\)/,
    '<a href="$2" target="_blank" rel="noopener">$1</a>',
  )
}
